import { useEffect, useRef } from 'react'
import { Toast } from '@zoom/react-ui'

interface ToastNotificationProps {
  type: 'info' | 'success' | 'error' | 'warning'
  content: string
  duration: number
  classes?: string
}

const ToastNotification = ({
  type,
  content,
  duration,
  classes,
}: ToastNotificationProps) => {
  const toastShown = useRef(false)

  useEffect(() => {
    if (!toastShown.current) {
      const toastTypes = {
        info: Toast.info,
        success: Toast.success,
        error: Toast.error,
        warning: Toast.warning,
      }
      const showToast = toastTypes[type]

      if (showToast) {
        showToast({
          content: content,
          closable: true,
          duration: duration,
          className: classes,
        })
      }

      toastShown.current = true
    }
  }, [type, content, duration, classes])

  return null
}

export default ToastNotification
